import { QRCodeCanvas } from "qrcode.react";
import { Button } from "components/ui/button";
import { Copy, Printer } from "@phosphor-icons/react";
import { toast } from "react-toastify";

const APP_BASE_URL = "https://app.yallyhub.be";

interface MaintenanceQRSectionProps {
  publicToken: string;
  scheduleName: string;
  assetName?: string;
  compact?: boolean;
}

export const MaintenanceQRSection = ({
  publicToken,
  scheduleName,
  assetName,
  compact = false,
}: MaintenanceQRSectionProps) => {
  const reportUrl = `${APP_BASE_URL}/report/maintenance/${publicToken}`;

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(reportUrl);
      toast.success("Link gekopieerd naar klembord");
    } catch (error) {
      toast.error("Kon link niet kopieren");
    }
  };

  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    if (!printWindow) return;

    const canvas = document.getElementById(
      `qr-maintenance-${publicToken}`
    ) as HTMLCanvasElement;
    if (!canvas) return;

    const dataUrl = canvas.toDataURL("image/png");
    const title = assetName
      ? `${scheduleName} - ${assetName}`
      : scheduleName;

    printWindow.document.write(`
      <html>
        <head><title>QR Code - ${title}</title></head>
        <body style="display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:100vh;font-family:system-ui,sans-serif;margin:0;padding:40px;">
          <div style="border:2px solid #e5e7eb;border-radius:16px;padding:32px;text-align:center;max-width:320px;">
            <h2 style="margin:0 0 4px;font-size:18px;font-weight:600;">${scheduleName}</h2>
            ${assetName ? `<p style="margin:0 0 8px;font-size:14px;color:#6b7280;">${assetName}</p>` : ''}
            <p style="margin:0 0 20px;font-size:13px;color:#6b7280;">Scan de QR code om een onderhoudsrapport in te dienen</p>
            <img src="${dataUrl}" style="width:200px;height:200px;margin:0 auto;" />
            <p style="margin:16px 0 0;font-size:11px;color:#9ca3af;">yallyhub.be</p>
          </div>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
  };

  const qrSize = compact ? 120 : 160;

  return (
    <div className="space-y-3">
      <div className="flex flex-col items-center rounded-lg border bg-background p-4">
        <div className="rounded-md bg-white p-3 shadow-sm">
          <QRCodeCanvas
            id={`qr-maintenance-${publicToken}`}
            value={reportUrl}
            size={qrSize}
            level="M"
            marginSize={1}
          />
        </div>
        <p className="mt-3 text-center text-xs text-muted-foreground">
          Scan om een onderhoudsrapport in te dienen
        </p>
      </div>
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          className="flex-1 h-8 text-xs"
          onClick={handleCopyLink}
        >
          <Copy className="mr-1 h-3.5 w-3.5" />
          Kopieer link
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="flex-1 h-8 text-xs"
          onClick={handlePrint}
        >
          <Printer className="mr-1 h-3.5 w-3.5" />
          Print
        </Button>
      </div>
    </div>
  );
};
